import React from "react";
import CommentCard from "../cards/CommentCard";

//  Image \\

//  Style \\
import "../../assets/styles/cards/comment.scss";

// Swipper \\
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Comment = () => {
  return (
    <section className="comment">
      <div className="comment_bg">
        <div className="container">
          <div className="comment_items">
            <div className="comment_items_cardBox">
              <Swiper
                className="swipperHead"
                modules={[Navigation, Pagination, Scrollbar, A11y]}
                spaceBetween={170}
                slidesPerView={1}
                pagination={{ clickable: true }}
                onSlideChange={() => console.log("slide change")}
              >
                <SwiperSlide>
                  <CommentCard />
                </SwiperSlide>
                <SwiperSlide>
                  <CommentCard />
                </SwiperSlide>
                <SwiperSlide>
                  <CommentCard />
                </SwiperSlide>

                <div className="dot">...</div>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comment;
